module.exports = flarum.core.compat['forum/utils/UserControls'];